// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type CreateAttachmentJsonRequest from '../contract/CreateAttachmentJsonRequest';

export default function createAttachmentJsonRequest(
    data: CreateAttachmentJsonRequest
): CreateAttachmentJsonRequest {
    const result: CreateAttachmentJsonRequest = {
        __type: 'CreateAttachmentJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
